import { deepClone } from "./lib/clone.js";

const TEMPLATE_MAP = {
  phul: {
    id: "phul",
    name: "PHUL (4-Day)",
    summary: "Power Hypertrophy Upper Lower split.",
    tags: ["phul", "upper", "lower", "power", "hypertrophy"],
    payload: {
      schemaVersion: 1,
      name: "PHUL",
      isActive: false,
      cycle: {
        type: "sequence",
        lengthDays: 4,
      },
      trial: 0,
      dayAliases: {
        "0": "Upper Power",
        "1": "Lower Power",
        "2": "Upper Hypertrophy",
        "3": "Lower Hypertrophy",
      },
      fixedWeekdayMap: null,
      days: {
        "0": {
          items: {
            "0": {
              exerciseId: "bench_press",
              sets: 3,
              restSec: 150,
              loadRule: {
                type: "percent1RM",
                percent: 85,
                rmBase: "bench",
              },
              repsRule: {
                type: "fixed",
                reps: 5,
              },
            },
            "1": {
              exerciseId: "barbell_row",
              sets: 3,
              restSec: 150,
              loadRule: null,
              repsRule: {
                type: "fixed",
                reps: 5,
              },
            },
            "2": {
              exerciseId: "overhead_press",
              sets: 3,
              restSec: 120,
              loadRule: {
                type: "percent1RM",
                percent: 80,
                rmBase: "bench",
              },
              repsRule: {
                type: "fixed",
                reps: 6,
              },
            },
          },
        },
        "1": {
          items: {
            "0": {
              exerciseId: "squat",
              sets: 3,
              restSec: 180,
              loadRule: {
                type: "percent1RM",
                percent: 85,
                rmBase: "squat",
              },
              repsRule: {
                type: "fixed",
                reps: 5,
              },
            },
            "1": {
              exerciseId: "deadlift",
              sets: 3,
              restSec: 180,
              loadRule: {
                type: "percent1RM",
                percent: 80,
                rmBase: "deadlift",
              },
              repsRule: {
                type: "fixed",
                reps: 5,
              },
            },
            "2": {
              exerciseId: "leg_press",
              sets: 3,
              restSec: 120,
              loadRule: null,
              repsRule: {
                type: "range",
                min: 8,
                max: 10,
              },
            },
          },
        },
        "2": {
          items: {
            "0": {
              exerciseId: "incline_dumbbell_press",
              sets: 4,
              restSec: 90,
              loadRule: null,
              repsRule: {
                type: "range",
                min: 8,
                max: 12,
              },
            },
            "1": {
              exerciseId: "lat_pulldown",
              sets: 4,
              restSec: 90,
              loadRule: null,
              repsRule: {
                type: "range",
                min: 10,
                max: 12,
              },
            },
            "2": {
              exerciseId: "cable_pushdown",
              sets: 3,
              restSec: 75,
              loadRule: null,
              repsRule: {
                type: "range",
                min: 10,
                max: 15,
              },
            },
          },
        },
        "3": {
          items: {
            "0": {
              exerciseId: "leg_press",
              sets: 4,
              restSec: 90,
              loadRule: null,
              repsRule: {
                type: "range",
                min: 12,
                max: 15,
              },
            },
            "1": {
              exerciseId: "leg_curl",
              sets: 4,
              restSec: 90,
              loadRule: null,
              repsRule: {
                type: "range",
                min: 10,
                max: 15,
              },
            },
            "2": {
              exerciseId: "calf_raise",
              sets: 4,
              restSec: 60,
              loadRule: null,
              repsRule: {
                type: "range",
                min: 12,
                max: 20,
              },
            },
          },
        },
      },
    },
  },
  nsuns531: {
    id: "nsuns531",
    name: "nSuns 5/3/1 (5-Day)",
    summary: "Linear progression style strength split.",
    tags: ["nsuns531", "nsuns", "531", "strength", "powerlifting"],
    payload: {
      schemaVersion: 1,
      name: "nSuns 5/3/1",
      isActive: false,
      cycle: {
        type: "sequence",
        lengthDays: 5,
      },
      trial: 0,
      dayAliases: {
        "0": "Bench Intensity",
        "1": "Squat Intensity",
        "2": "OHP Intensity",
        "3": "Deadlift Intensity",
        "4": "Bench Volume",
      },
      fixedWeekdayMap: null,
      days: {
        "0": {
          items: {
            "0": {
              exerciseId: "bench_press",
              sets: 8,
              restSec: 120,
              loadRule: {
                type: "percent1RM",
                percent: 82,
                rmBase: "bench",
              },
              repsRule: {
                type: "fixed",
                reps: 3,
              },
            },
            "1": {
              exerciseId: "incline_dumbbell_press",
              sets: 4,
              restSec: 90,
              loadRule: null,
              repsRule: {
                type: "range",
                min: 8,
                max: 12,
              },
            },
          },
        },
        "1": {
          items: {
            "0": {
              exerciseId: "squat",
              sets: 8,
              restSec: 150,
              loadRule: {
                type: "percent1RM",
                percent: 82,
                rmBase: "squat",
              },
              repsRule: {
                type: "fixed",
                reps: 3,
              },
            },
            "1": {
              exerciseId: "leg_press",
              sets: 4,
              restSec: 90,
              loadRule: null,
              repsRule: {
                type: "range",
                min: 10,
                max: 15,
              },
            },
          },
        },
        "2": {
          items: {
            "0": {
              exerciseId: "overhead_press",
              sets: 8,
              restSec: 120,
              loadRule: {
                type: "percent1RM",
                percent: 80,
                rmBase: "bench",
              },
              repsRule: {
                type: "fixed",
                reps: 3,
              },
            },
            "1": {
              exerciseId: "lat_pulldown",
              sets: 4,
              restSec: 90,
              loadRule: null,
              repsRule: {
                type: "range",
                min: 8,
                max: 12,
              },
            },
          },
        },
        "3": {
          items: {
            "0": {
              exerciseId: "deadlift",
              sets: 6,
              restSec: 150,
              loadRule: {
                type: "percent1RM",
                percent: 82,
                rmBase: "deadlift",
              },
              repsRule: {
                type: "fixed",
                reps: 3,
              },
            },
            "1": {
              exerciseId: "barbell_row",
              sets: 4,
              restSec: 90,
              loadRule: null,
              repsRule: {
                type: "range",
                min: 8,
                max: 12,
              },
            },
          },
        },
        "4": {
          items: {
            "0": {
              exerciseId: "bench_press",
              sets: 9,
              restSec: 120,
              loadRule: {
                type: "percent1RM",
                percent: 75,
                rmBase: "bench",
              },
              repsRule: {
                type: "fixed",
                reps: 5,
              },
            },
            "1": {
              exerciseId: "dips",
              sets: 4,
              restSec: 90,
              loadRule: null,
              repsRule: {
                type: "range",
                min: 8,
                max: 15,
              },
            },
          },
        },
      },
    },
  },
  pullpush_korean_4day: {
    id: "pullpush_korean_4day",
    name: "Pull/Push 4-Day (KOR Custom)",
    summary: "Pull 1/2 + Push 1/2 구성의 4일 루틴.",
    tags: ["pull", "push", "4day", "custom", "korean"],
    payload: {
      schemaVersion: 1,
      name: "Pull Push 4-Day Custom",
      isActive: false,
      cycle: {
        type: "sequence",
        lengthDays: 4,
      },
      trial: 0,
      dayAliases: {
        "0": "Pull 1",
        "1": "Pull 2",
        "2": "Push 1",
        "3": "Push 2",
      },
      fixedWeekdayMap: null,
      days: {
        "0": {
          items: {
            "0": { exerciseId: "pull_up", sets: 3, restSec: 120, loadRule: null, repsRule: null },
            "1": { exerciseId: "barbell_row", sets: 5, restSec: 120, loadRule: null, repsRule: null },
            "2": { exerciseId: "seated_row", sets: 5, restSec: 90, loadRule: null, repsRule: null },
            "3": { exerciseId: "shrug", sets: 2, restSec: 90, loadRule: null, repsRule: null },
            "4": { exerciseId: "reverse_fly", sets: 4, restSec: 75, loadRule: null, repsRule: null },
            "5": { exerciseId: "barbell_curl", sets: 3, restSec: 75, loadRule: null, repsRule: null },
            "6": { exerciseId: "hammer_curl", sets: 3, restSec: 75, loadRule: null, repsRule: null },
            "7": { exerciseId: "leg_curl", sets: 4, restSec: 90, loadRule: null, repsRule: null },
          },
        },
        "1": {
          items: {
            "0": { exerciseId: "straight_arm_pulldown", sets: 3, restSec: 90, loadRule: null, repsRule: null },
            "1": { exerciseId: "deadlift", sets: 5, restSec: 150, loadRule: null, repsRule: null },
            "2": { exerciseId: "lat_pulldown", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "3": { exerciseId: "cable_high_row", sets: 3, restSec: 90, loadRule: null, repsRule: null },
            "4": { exerciseId: "face_pull", sets: 4, restSec: 75, loadRule: null, repsRule: null },
            "5": { exerciseId: "incline_curl", sets: 4, restSec: 75, loadRule: null, repsRule: null },
            "6": { exerciseId: "leg_curl", sets: 4, restSec: 90, loadRule: null, repsRule: null },
          },
        },
        "2": {
          items: {
            "0": { exerciseId: "bench_press", sets: 5, restSec: 120, loadRule: null, repsRule: null },
            "1": { exerciseId: "cable_fly", sets: 4, restSec: 75, loadRule: null, repsRule: null },
            "2": { exerciseId: "dumbbell_shoulder_press", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "3": { exerciseId: "lateral_raise", sets: 4, restSec: 75, loadRule: null, repsRule: null },
            "4": { exerciseId: "lying_triceps_extension", sets: 4, restSec: 75, loadRule: null, repsRule: null },
            "5": { exerciseId: "cable_pushdown", sets: 3, restSec: 75, loadRule: null, repsRule: null },
            "6": { exerciseId: "leg_extension", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "7": { exerciseId: "hip_thrust", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "8": { exerciseId: "calf_raise", sets: 3, restSec: 75, loadRule: null, repsRule: null },
          },
        },
        "3": {
          items: {
            "0": { exerciseId: "incline_dumbbell_press", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "1": { exerciseId: "cable_fly", sets: 3, restSec: 75, loadRule: null, repsRule: null },
            "2": { exerciseId: "overhead_press", sets: 5, restSec: 120, loadRule: null, repsRule: null },
            "3": { exerciseId: "lateral_raise", sets: 4, restSec: 75, loadRule: null, repsRule: null },
            "4": { exerciseId: "close_grip_bench_press", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "5": { exerciseId: "dumbbell_kickback", sets: 3, restSec: 75, loadRule: null, repsRule: null },
            "6": { exerciseId: "leg_extension", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "7": { exerciseId: "hip_thrust", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "8": { exerciseId: "calf_raise", sets: 3, restSec: 75, loadRule: null, repsRule: null },
          },
        },
      },
    },
  },
  split4_plus_arm_5day_kor: {
    id: "split4_plus_arm_5day_kor",
    name: "4분할+팔 (5-Day KOR)",
    summary: "가슴/등/어깨/하체/팔 구성의 5일 순환 루틴.",
    tags: ["4분할", "팔", "5day", "split", "korean", "chest", "back", "legs"],
    payload: {
      schemaVersion: 1,
      name: "4분할+팔",
      isActive: false,
      cycle: {
        type: "sequence",
        lengthDays: 5,
      },
      trial: 0,
      dayAliases: {
        "0": "가슴, 삼두",
        "1": "등, 이두",
        "2": "어깨, 팔",
        "3": "하체",
        "4": "팔",
      },
      fixedWeekdayMap: null,
      days: {
        "0": {
          items: {
            "0": { exerciseId: "dumbbell_pullover", sets: 3, restSec: 90, loadRule: null, repsRule: null },
            "1": { exerciseId: "bench_press", sets: 8, restSec: 90, loadRule: null, repsRule: null },
            "2": { exerciseId: "incline_dumbbell_press", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "3": { exerciseId: "cable_fly", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "4": { exerciseId: "close_grip_bench_press", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "5": { exerciseId: "lying_triceps_extension", sets: 4, restSec: 90, loadRule: null, repsRule: null },
          },
        },
        "1": {
          items: {
            "0": { exerciseId: "deadlift", sets: 8, restSec: 120, loadRule: null, repsRule: null },
            "1": { exerciseId: "barbell_row", sets: 4, restSec: 120, loadRule: null, repsRule: null },
            "2": { exerciseId: "pull_up", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "3": { exerciseId: "seated_row", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "4": { exerciseId: "lat_pulldown", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "5": { exerciseId: "ez_bar_curl", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "6": { exerciseId: "incline_curl", sets: 4, restSec: 90, loadRule: null, repsRule: null },
          },
        },
        "2": {
          items: {
            "0": { exerciseId: "overhead_press", sets: 8, restSec: 120, loadRule: null, repsRule: null },
            "1": { exerciseId: "arnold_press", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "2": { exerciseId: "lateral_raise", sets: 4, restSec: 90, loadRule: null, repsRule: { type: "fixed", reps: 25 } },
            "3": { exerciseId: "reverse_fly", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "4": { exerciseId: "barbell_curl", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "5": { exerciseId: "lying_triceps_extension", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "6": { exerciseId: "cable_curl", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "7": { exerciseId: "cable_pushdown", sets: 4, restSec: 90, loadRule: null, repsRule: null },
          },
        },
        "3": {
          items: {
            "0": { exerciseId: "squat", sets: 8, restSec: 120, loadRule: null, repsRule: null },
            "1": { exerciseId: "leg_curl", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "2": { exerciseId: "leg_extension", sets: 4, restSec: 90, loadRule: null, repsRule: null },
          },
        },
        "4": {
          items: {
            "0": { exerciseId: "ez_bar_curl", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "1": { exerciseId: "lying_triceps_extension", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "2": { exerciseId: "incline_curl", sets: 4, restSec: 90, loadRule: null, repsRule: null },
            "3": { exerciseId: "dumbbell_kickback", sets: 4, restSec: 90, loadRule: null, repsRule: null },
          },
        },
      },
    },
  },
};

export function listProgramTemplates() {
  return Object.values(TEMPLATE_MAP).map((template) => ({
    id: template.id,
    name: template.name,
    summary: template.summary,
    lengthDays: template.payload.cycle.lengthDays,
    tags: template.tags,
  }));
}

export function createProgramPayloadFromTemplate(templateId) {
  const template = TEMPLATE_MAP[templateId];
  if (!template) {
    return null;
  }
  return deepClone(template.payload);
}
